module.exports = __webpack_public_path__ + "img/icon-avatar.6167cefb.svg";